import type { AnyAction } from 'redux';

import type { DuplexerData } from '@wix/a11y-adapters/studio';

export const SET_DUPLEXER_DATA = 'a11yWizardDuplexer/setDuplexerData';

export interface A11yWizardDuplexerScopedState {
  a11yWizardDuplexerState: A11yWizardDuplexerState;
}

export interface A11yWizardDuplexerState {
  duplexerData: DuplexerData | undefined;
}

const initialState: A11yWizardDuplexerState = {
  duplexerData: undefined,
};

export const a11yWizardDuplexerActions = {
  setDuplexerData: (duplexerData: DuplexerData | undefined) => ({
    type: SET_DUPLEXER_DATA,
    value: { duplexerData },
  }),
};

export const a11yWizardDuplexerReducer = (
  state: A11yWizardDuplexerState = initialState,
  action: AnyAction,
): A11yWizardDuplexerState => {
  switch (action.type) {
    case SET_DUPLEXER_DATA:
      return { ...state, ...action.value };
    default:
      return state;
  }
};

export const createA11yWizardDuplexerSelector = (
  getState: () => A11yWizardDuplexerState,
) => ({
  getDuplexerData: () => getState(),
});
